import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import { formatLink } from "@app/util/formatters";

import styles from "./Common.module.scss";

const CrmLinkCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  if (!value) {
    return <>{""}</>;
  }
  return (
    <div className={styles.ellipsis}>
      <a href={formatLink(value as string)} rel="noopener noreferrer" target="_blank">
        {value}
      </a>
    </div>
  );
};

export default CrmLinkCellRenderer;
